module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Gary M. Williams was born and raised in Staten Island, New York. He was a teacher and principal with the New York City Department of Education for thirty-five years. He is currently retired and resides in Manhattan and is now assuming a full-time career in writing.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("He was inspired to write a historical fictional novel spanning the twentieth century after visits to Newport, Rhode Island, and Europe. After two years of research and eight years of writing, "), _c('em', [_vm._v("Gone but Not Forgotten")]), _vm._v(", the first of a trilogy, along with the second and third books, reached their completion.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("In addition to writing, Mr. Williams holds a strong avocation for the arts. His hobbies include theater, reading, and world travel. He is currently working on his next novel and anticipates adding it to his literary repertoire.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0